export class ServicoEntrega {
  id: number;
  de: number;
  ate: number;
  valor: number;
}
